import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBan,
  faFile,
  faFileInvoiceDollar,
  faPrint,
  faShoppingCart,
  faUndoAlt,
  faSignOutAlt,
  faCircleXmark,
  faRefresh,
} from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";
import Reimpressao from "./Reimpressao";
import { Button, Modal } from "antd";
import Cancelamento from "./Cancelamento";
import TelaVendas from "./TelaVendas";
import Orcamentos from "./Orcamentos/Orcamentos";
import Devolucao from "./Devolucao";
import Log from "./Log/Log";
import { useConfigQuery } from "../../../queries/useConfig";
import axios from "axios";
import ExportacaoNotasEntradaTabela from "./ExportacaoNotasEntradaTabela";
import TelaNfse from "./TelaNfse";

const Vendas = () => {
  const { data: config, error } = useConfigQuery();
  const [key, setKey] = React.useState(0);

  const [isModalVisible, setIsModalVisible] = useState(false);

  // ✅ em vez de guardar JSX "congelado", guarda só QUAL tela abrir
  const [modalKey, setModalKey] = useState(null);

  const [pagamentoConcluido, setPagamentoConcluido] = useState(false);
  const [pagamentos, setPagamentos] = useState([]);
  const [produtos, setProdutos] = useState([]);
  const [consumidorIdentificado, setConsumidorIdentificado] = useState(false);
  const [consumidor, setConsumidor] = useState(null);

  const [msgSairTela, setMsgSairTela] = useState("");
  const accessToken = window.localStorage.getItem("accessToken");
  const [loading, setLoading] = useState(false);
  const [pagItem, setPagItem] = useState([]);


  const resetStates = () => {
    setProdutos([]);
    setKey((prevKey) => prevKey + 1);
  };

  const bloquearAcesso = (palavra) => {
    if (!palavra) return false;

    const bloqueios = config?.bloqueiosDoUsuario;
    if (!bloqueios) return false;

    return bloqueios.toLowerCase().includes(String(palavra).toLowerCase());
  };

  // ✅ agora abre por "key" (vendas, orcamentos, etc.)
  const handleOpenModal = (key) => {
    setModalKey(key);
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
    setModalKey(null);
  };

  const recuperarVenda = async () => {
    try {
      setLoading(true);
      const options = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      };

      const { data } = await axios.get(
        `https://apihomologtechspdv.techspdv.com.br/v1/venda-abandonada/${config?.idLoja}/${modalKey}`,
        options
      );

      const itens = Array.isArray(data?.produtos) ? data.produtos : [];
      setProdutos(itens.map((p) => ({ ...p })));
      setPagamentoConcluido(data?.pagamentoConcluido);
      setPagamentos(data?.pagamentos);
      setConsumidor(data?.consumidor);
      setConsumidorIdentificado(data?.consumidorIdentificado);
      setPagItem(data?.pagItem);



      setLoading(false);
    } catch (error) {
      console.log("Erro recuperarVenda:", error);
      setProdutos([]);
      setLoading(false);
    }
  };

  const handleExitClick = async () => {
    resetStates();
    handleCloseModal();
  };

  // ✅ evita "stale state" quando adiciona rápido
  const trataProdutos = (produto) => {
    setProdutos((prev) => [...prev, produto]);
  };

  return (
    <PaginaContainer key={key}>
      <PainelPrincipal>
        <CabecalhoPagina>
          <div>
            <TituloPagina>
              Documentos Fiscais
            </TituloPagina>

            <SubtituloPagina>
              Selecione uma operação para iniciar
            </SubtituloPagina>
          </div>

          <IconeCabecalho>
            🧾
          </IconeCabecalho>
        </CabecalhoPagina>

        <GridOperacoes>
          {/* NF-e */}
          <CardOperacao
            type="button"
            $corInicial="#7c3aed"
            $corFinal="#5b21b6"
            onClick={() => {
              handleOpenModal("vendas");
              setMsgSairTela(
                "Deseja abandonar a Venda?"
              );
            }}
            disabled={bloquearAcesso("ve.vendas")}
          >
            <AreaIcone>
              <FontAwesomeIcon
                icon={faShoppingCart}
                size="2x"
              />
            </AreaIcone>

            <ConteudoCard>
              <TituloCard>
                NF-e
              </TituloCard>

              <DescricaoCard>
                Emissão de nota fiscal eletrônica
              </DescricaoCard>
            </ConteudoCard>

            <IndicadorCard>
              →
            </IndicadorCard>
          </CardOperacao>

          {/* NFS-e */}
          <CardOperacao
            type="button"
            $corInicial="#9333ea"
            $corFinal="#6b21a8"
            onClick={() => {
              handleOpenModal("nfse");
              setMsgSairTela(
                "Deseja abandonar a Venda?"
              );
            }}
            disabled={bloquearAcesso("ve.vendas")}
          >
            <AreaIcone>
              <FontAwesomeIcon
                icon={faShoppingCart}
                size="2x"
              />
            </AreaIcone>

            <ConteudoCard>
              <TituloCard>
                NFS-e
              </TituloCard>

              <DescricaoCard>
                Emissão de nota fiscal de serviço
              </DescricaoCard>
            </ConteudoCard>

            <IndicadorCard>
              →
            </IndicadorCard>
          </CardOperacao>

          {/* Entrada */}
          <CardOperacao
            type="button"
            $corInicial="#2563eb"
            $corFinal="#1d4ed8"
            onClick={() => {
              handleOpenModal("xml");
              setMsgSairTela(
                "Deseja abandonar a Venda?"
              );
            }}
          >
            <AreaIcone>
              <FontAwesomeIcon
                icon={faShoppingCart}
                size="2x"
              />
            </AreaIcone>

            <ConteudoCard>
              <TituloCard>
                Entrada
              </TituloCard>

              <DescricaoCard>
                Importação e consulta de notas de entrada
              </DescricaoCard>
            </ConteudoCard>

            <IndicadorCard>
              →
            </IndicadorCard>
          </CardOperacao>

          {/* NFC-e */}
          <CardOperacao
            type="button"
            $corInicial="#f59e0b"
            $corFinal="#d97706"
            onClick={() => {
              handleOpenModal("orcamentos");
              setMsgSairTela(
                "Deseja abandonar o Orçamento?"
              );
            }}
            disabled={bloquearAcesso(
              "ve.orcamentos"
            )}
          >
            <AreaIcone>
              <FontAwesomeIcon
                icon={faFileInvoiceDollar}
                size="2x"
              />
            </AreaIcone>

            <ConteudoCard>
              <TituloCard>
                NFC-e
              </TituloCard>

              <DescricaoCard>
                Emissão de cupom fiscal eletrônico
              </DescricaoCard>
            </ConteudoCard>

            <IndicadorCard>
              →
            </IndicadorCard>
          </CardOperacao>
        </GridOperacoes>
      </PainelPrincipal>

      <Modal
        visible={isModalVisible}
        onCancel={handleExitClick}
        footer={null}
        width="100%"
        style={{ top: 0 }}
        centered
        closeIcon={null}
        className="full-screen-modal"
        bodyStyle={{
          padding: 0,
        }}
      >
        <ModalHeader>
          <div>
            <TituloModal>
              {modalKey === "vendas" &&
                "Emissão de NF-e"}

              {modalKey === "nfse" &&
                "Emissão de NFS-e"}

              {modalKey === "xml" &&
                "Notas de Entrada"}

              {modalKey === "orcamentos" &&
                "Emissão de NFC-e"}

              {modalKey === "cancelamento" &&
                "Cancelamento"}

              {modalKey === "devolucao" &&
                "Devolução"}

              {modalKey === "reimpressao" &&
                "Reimpressão"}

              {modalKey === "log" &&
                "Logs"}
            </TituloModal>
          </div>

          <BotaoAbandonar
            type="button"
            onClick={handleExitClick}
          >
            <span>Abandonar</span>

            <FontAwesomeIcon
              icon={faSignOutAlt}
            />
          </BotaoAbandonar>
        </ModalHeader>

        <ModalBody>
          {modalKey === "vendas" && (
            <TelaVendas
              produtos={produtos}
              setProdutos={setProdutos}
              trataProdutos={trataProdutos}
              pagamentoConcluido={
                pagamentoConcluido
              }
              setPagamentoConcluido={
                setPagamentoConcluido
              }
              pagamentos={pagamentos}
              setPagamentos={setPagamentos}
              consumidorIdentificado={
                consumidorIdentificado
              }
              setConsumidorIdentificado={
                setConsumidorIdentificado
              }
              consumidor={consumidor}
              setConsumidor={setConsumidor}
              pagItem={pagItem}
              setPagItem={setPagItem}
            />
          )}

          {modalKey === "nfse" && (
            <TelaNfse
              produtos={produtos}
              setProdutos={setProdutos}
              trataProdutos={trataProdutos}
              pagamentoConcluido={
                pagamentoConcluido
              }
              setPagamentoConcluido={
                setPagamentoConcluido
              }
              pagamentos={pagamentos}
              setPagamentos={setPagamentos}
              consumidorIdentificado={
                consumidorIdentificado
              }
              setConsumidorIdentificado={
                setConsumidorIdentificado
              }
              consumidor={consumidor}
              setConsumidor={setConsumidor}
              pagItem={pagItem}
              setPagItem={setPagItem}
            />
          )}

          {modalKey === "xml" && (
            <ExportacaoNotasEntradaTabela
              produtos={produtos}
              setProdutos={setProdutos}
              trataProdutos={trataProdutos}
              pagamentoConcluido={
                pagamentoConcluido
              }
              setPagamentoConcluido={
                setPagamentoConcluido
              }
              pagamentos={pagamentos}
              setPagamentos={setPagamentos}
              consumidorIdentificado={
                consumidorIdentificado
              }
              setConsumidorIdentificado={
                setConsumidorIdentificado
              }
              consumidor={consumidor}
              setConsumidor={setConsumidor}
              pagItem={pagItem}
              setPagItem={setPagItem}
            />
          )}

          {modalKey === "orcamentos" && (
            <Orcamentos
              produtos={produtos}
              setProdutos={setProdutos}
              trataProdutos={trataProdutos}
              pagamentoConcluido={
                pagamentoConcluido
              }
              setPagamentoConcluido={
                setPagamentoConcluido
              }
              pagamentos={pagamentos}
              setPagamentos={setPagamentos}
              consumidorIdentificado={
                consumidorIdentificado
              }
              setConsumidorIdentificado={
                setConsumidorIdentificado
              }
              consumidor={consumidor}
              setConsumidor={setConsumidor}
              pagItem={pagItem}
              setPagItem={setPagItem}
            />
          )}

          {modalKey === "cancelamento" && (
            <Cancelamento />
          )}

          {modalKey === "devolucao" && (
            <Devolucao />
          )}

          {modalKey === "reimpressao" && (
            <Reimpressao />
          )}

          {modalKey === "log" && (
            <Log />
          )}
        </ModalBody>
      </Modal>
    </PaginaContainer>
  );
};

const PaginaContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  padding: 24px;
  background: #f4f6f9;
  box-sizing: border-box;
`;

const PainelPrincipal = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 22px;

  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 18px;

  box-shadow: 0 10px 30px
    rgba(15, 23, 42, 0.08);

  box-sizing: border-box;
`;

const CabecalhoPagina = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  padding-bottom: 18px;
  margin-bottom: 20px;

  border-bottom: 1px solid #e5e7eb;
`;

const TituloPagina = styled.h1`
  margin: 0;

  color: #111827;

  font-size: 25px;
  font-weight: 800;
`;

const SubtituloPagina = styled.span`
  display: block;
  margin-top: 4px;

  color: #6b7280;

  font-size: 14px;
`;

const IconeCabecalho = styled.div`
  width: 52px;
  height: 52px;

  display: flex;
  align-items: center;
  justify-content: center;

  flex-shrink: 0;

  background: #f3f4f6;
  border-radius: 14px;

  font-size: 27px;
`;

const GridOperacoes = styled.div`
  display: grid;
  grid-template-columns:
    repeat(2, minmax(0, 1fr));
  gap: 16px;

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
  }
`;

const CardOperacao = styled.button`
  position: relative;

  min-height: 138px;
  padding: 20px;

  display: flex;
  align-items: center;
  gap: 16px;

  overflow: hidden;

  border: none;
  border-radius: 16px;

  color: #ffffff;
  text-align: left;

  background: linear-gradient(
    135deg,
    ${({ $corInicial }) =>
    $corInicial},
    ${({ $corFinal }) =>
    $corFinal}
  );

  cursor: pointer;

  box-shadow:
    0 8px 20px
      rgba(15, 23, 42, 0.16),
    inset 0 1px 0
      rgba(255, 255, 255, 0.16);

  transition:
    transform 0.18s ease,
    box-shadow 0.18s ease,
    filter 0.18s ease;

  &:hover:not(:disabled) {
    transform: translateY(-3px);
    filter: brightness(1.05);

    box-shadow:
      0 13px 26px
        rgba(15, 23, 42, 0.22),
      inset 0 1px 0
        rgba(255, 255, 255, 0.18);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.45;
    filter: grayscale(0.35);
    box-shadow: none;
  }

  &::after {
    content: "";

    position: absolute;
    right: -25px;
    bottom: -55px;

    width: 150px;
    height: 150px;

    background:
      rgba(255, 255, 255, 0.08);

    border-radius: 50%;
  }
`;

const AreaIcone = styled.div`
  width: 62px;
  height: 62px;

  display: flex;
  align-items: center;
  justify-content: center;

  flex-shrink: 0;

  background:
    rgba(255, 255, 255, 0.17);

  border: 1px solid
    rgba(255, 255, 255, 0.18);

  border-radius: 15px;
`;

const ConteudoCard = styled.div`
  display: flex;
  flex-direction: column;

  min-width: 0;
  flex: 1;
`;

const TituloCard = styled.span`
  color: #ffffff;

  font-size: 22px;
  font-weight: 800;
  line-height: 1.2;
`;

const DescricaoCard = styled.span`
  margin-top: 5px;

  color:
    rgba(255, 255, 255, 0.86);

  font-size: 13px;
  font-weight: 500;
  line-height: 1.4;
`;

const IndicadorCard = styled.span`
  position: relative;
  z-index: 1;

  width: 34px;
  height: 34px;

  display: flex;
  align-items: center;
  justify-content: center;

  flex-shrink: 0;

  background:
    rgba(255, 255, 255, 0.16);

  border-radius: 50%;

  color: #ffffff;

  font-size: 20px;
  font-weight: 800;
`;

const ModalHeader = styled.div`
  width: 100%;
  min-height: 64px;
  padding: 10px 18px;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;

  background: #ffffff;
  border-bottom: 1px solid #e5e7eb;

  box-sizing: border-box;
`;

const TituloModal = styled.h2`
  margin: 0;

  color: #111827;

  font-size: 18px;
  font-weight: 800;
`;

const BotaoAbandonar = styled.button`
  min-height: 42px;
  padding: 9px 17px;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  border: 1px solid #dc2626;
  border-radius: 9px;

  background: linear-gradient(
    135deg,
    #ef4444,
    #b91c1c
  );

  color: #ffffff;

  font-size: 14px;
  font-weight: 800;

  cursor: pointer;

  box-shadow:
    0 5px 12px
      rgba(220, 38, 38, 0.2);

  transition:
    transform 0.15s ease,
    filter 0.15s ease;

  &:hover {
    transform: translateY(-1px);
    filter: brightness(1.05);
  }
`;

const ModalBody = styled.div`
  width: 100%;
  height: calc(100vh - 64px);

  margin: 0;
  padding: 0;

  overflow: auto;

  background: #f4f6f9;
`;

export default Vendas;
